import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import { Stack, Typography, useTheme } from "@mui/material"
import { ReactElement, useContext } from "react"

import { ReactComponent as CelebrationSvg } from "../../../assets/celebration.svg"
import { useAppDispatch } from "../../../hooks/useDispatch"
import { useGetUserData } from "../../../hooks/useGetUserData"
import { setShowAccountSetUp } from "../../../redux/preferencesSlice"
import { SUPPRESSED } from "../../../redux/types"
import AppButton from "../../buttons/appButton"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"
import { AccountSetUpContext } from "../providers/firstLoginProvider"

/** Displayed when an invite has been accepted successfully */
const InviteAcceptedSuccess = (): ReactElement => {
    const { invite } = useContext(AccountSetUpContext)
    const { onSignOut } = useGetUserData()
    const dispatch = useAppDispatch()
    const theme = useTheme()
    const manufacturerApprovalNote =
        invite?.organisationType === "manufacturer"
            ? [
                  `Please note that ${invite?.inviter} will need to approve your account before you get fully access.`,
                  "We have let them know on your behalf.",
              ].join(" ")
            : ""
    const inviteAcceptedSubtitle = `You have successfully joined ${invite?.organisationName}. ${manufacturerApprovalNote}`

    return (
        <FullScreenTitleContent
            titlePrimaryColor=""
            titleMain="Invite Successfully Accepted!"
            customSvg={
                <CelebrationSvg
                    fill={theme.palette.success.main}
                    viewBox="250 -50 40 700"
                />
            }
            subtitle={inviteAcceptedSubtitle}
            content={
                <Stack alignItems="center" width="100%" spacing={12}>
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        To finish the process, we need you to log out and log
                        back in again. Click the button below to sign out.
                    </Typography>

                    <CheckCircleOutlineIcon
                        sx={{
                            color: theme.palette.success.main,
                            fontSize: "250px",
                        }}
                    />
                </Stack>
            }
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <AppButton
                        fullWidth
                        variant="contained"
                        color="success"
                        onClick={() => {
                            onSignOut()
                            dispatch(setShowAccountSetUp(SUPPRESSED))
                        }}
                    >
                        Finish
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default InviteAcceptedSuccess
